import { EduButton } from '@edulastic/common'
import React from 'react'
import styled from 'styled-components'
import {
  dangerColor,
  fadedBlack2,
  greenPrimary,
  greyThemeDark1,
  lightGreen10,
  lightGrey,
  smallDesktopWidth,
  themeColorBlue,
  white,
  black,
} from '@edulastic/colors'
import {
  Drawer,
  Form,
  Menu,
  Modal,
  Tabs,
  Tooltip,
  Typography,
  Select,
} from 'antd'
import { ConfirmationModal } from '../../src/components/common/ConfirmationModal'
import { ANSWER_OPTION_DELIMITER } from '../constants/test'

const { Text } = Typography

const PEAR_ASSIST_STANDARD_SET_SELECT_COLOR = '#151D34'

export const StyledFooter = styled.div`
  background: #fff;
  bottom: 24px;
  width: 100%;
  position: absolute;
  box-shadow: 0px -2px 5px 0px #0000001f;
  padding: 12px 24px;
  height: 90px;
  margin: ${({ margin }) => margin || `-24px`};
`

export const StyledAIContentBorderWrapper = styled.div`
  border: double 1px transparent;
  border-radius: 4px;
  background-image: linear-gradient(white, white),
    linear-gradient(
      250.79deg,
      #257eed 3.18%,
      #429dc4 24.86%,
      #4dc3d8 67.26%,
      #017d69 96.39%
    );
  background-origin: border-box;
  background-clip: content-box, border-box;

  > div:first-child {
    padding: 16px;
  }
`
export const InlineSVG = styled.span`
  svg {
    float: left;
  }
`
export const FooterButton = styled(EduButton)`
  width: 100%;
  font-size: 14px;
  color: ${({ type }) =>
    type === 'default' ? greenPrimary : 'white'} !important;

  svg,
  &:hover svg {
    fill: ${({ type }) =>
      type === 'default' ? greenPrimary : 'white'} !important;
  }
`

export const StyledForm = styled(Form)`
  font-family: 'Open Sans';

  .ant-form-item-label {
    .ant-form-item-required {
      font-weight: 700;
      text-transform: uppercase;

      &::before {
        content: '';
        margin-right: 0;
      }

      &::after {
        display: inline-block;
        color: ${dangerColor};
        content: '*';
      }
    }

    label {
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;

      &::after {
        content: '';
      }
    }
  }

  .ant-input {
    background-color: ${lightGrey};
  }

  .ant-radio-group {
    .ant-radio-wrapper {
      .ant-radio-checked {
        .ant-radio-inner {
          border-color: ${lightGreen10};

          &::after {
            background-color: ${lightGreen10};
          }
        }
      }
    }
  }

  .has-error {
    .custom-tree-select,
    textarea:not(.standards-set textarea),
    textarea:not(.standards-set textarea):hover {
      border-color: ${dangerColor} !important;
    }

    .ant-select-selection:not(.standards-set .ant-select-selection),
    .ant-select-selection:not(.standards-set .ant-select-selection):hover {
      border-color: ${dangerColor} !important;
    }
  }
`
export const StyledStandardSet = styled.div`
  span {
    height: 34px;
    line-height: 34px;
  }

  div[data-cy='standardBrowseButton'] {
    line-height: 0px;
  }

  .anticon-close {
    line-height: 36px;
  }
`

export const StyledGradientText = styled.span`
  margin-left: 6px;
  margin-right: ${(props) => props?.marginRight || 'unset'};
  line-height: 24px;
  background: linear-gradient(269.33deg, #007d65 0%, #1766ce 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: Open Sans;
  font-size: 12px;
  font-weight: ${(props) => props?.fontWeight || 500};
  line-height: 16.34px;
`

export const StyledAIFeaturesSubscriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledAIFeaturesText = styled.span`
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 500;
  line-height: 16.34px;
  text-align: left;
  color: ${fadedBlack2};
`
export const StyledAiTestDrawer = styled(Drawer)`
  .ant-drawer-content {
    overflow: hidden;

    .ant-drawer-body {
      padding: 0px !important;
      height: calc(100vh - 60px);
      padding-bottom: 0;
    }

    .ant-drawer-header {
      border-bottom: revert;
    }
  }
`
export const StyledDrawerTitle = styled.span`
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 21.79px;
  text-align: left;
  color: ${greyThemeDark1};
`
export const StyledAIEnhanceQuestionFooter = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  padding: 12px 24px;
  margin: -24px;
  background: #fff;
  box-shadow: 0px -2px 5px 0px #0000001f;
  height: 80px;
`
export const StyledAIEnhanceQuestionRegenerateButton = styled.div`
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  color: ${(props) => (props?.disabled ? '#b3e8de' : '#1ab395')};
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  cursor: ${(props) => (props?.disabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${(props) => (props?.disabled ? 'none' : 'auto')};

  svg {
    path {
      fill: ${(props) => (props?.disabled ? '#b3e8de' : '#1ab395')} !important;
    }
  }
`
export const StyledAIEnhanceQuestionTabs = styled(Tabs)`
  &.ant-tabs {
    height: 100%;

    .ant-tabs-bar {
      padding: 0px 24px;
    }

    .ant-tabs-content {
      height: calc(100% - 70px) !important;

      .ant-tabs-tabpane {
        padding: 0px 24px;
      }
    }
  }
`
export const StyledAIEnhanceQuestionContainer = styled.div`
  height: calc(100% - 70px);
  overflow: auto;
  padding: 2px;
`

export const StyledRadioGroupContainer = styled.div`
  margin-top: 16px;
  margin-bottom: 16px;
`

export const StyledRadioButtonContainer = styled.div`
  margin-bottom: 16px;
`

export const StyledUseOldQuestionAlertModal = styled(ConfirmationModal)`
  min-width: 442px !important;

  .ant-modal-content {
    padding: 0px 0px 25px 0px !important;

    .ant-modal-body {
      display: block !important;
      min-height: 0px !important;
      margin: 0px !important;
      padding: 25px !important;

      p {
        font-family: Open Sans;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        text-align: center;
        color: #000000;
      }
    }
  }
`

export const StyledMenuItem = styled(Menu.Item)`
  &:hover {
    background-color: ${themeColorBlue} !important;
    color: white !important;
  }
`
export const StyledOriginalQuestionText = styled(Text)`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  margin-bottom: 7px;
`

export const StyledQuestionListItem = styled.li`
  ::before {
    content: counter(list-item, upper-alpha) '${ANSWER_OPTION_DELIMITER}\\00A0\\00A0\\00A0';
  }

  ${({ isBold }) => isBold && `font-weight: bold;`}

  list-style-type: none !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
`

export const StyledAIAssistanceContainer = styled.div`
  position: sticky;
  top: 0;
  align-self: flex-start;
  width: 358px;
  min-width: 358px;
  min-height: 242px;
  max-height: 100vh;
  background: ${white};
  border-radius: 4px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  @media (max-width: ${smallDesktopWidth}) {
    width: 100%;
    min-width: unset;
    margin-left: 0;
    margin-top: 0;
    position: relative;
    top: 0;
    max-height: none;
  }
`

export const StyledHeaderSection = styled.div`
  padding: 20px 0px 20px 10px;
  flex-shrink: 0;
  background: #f1fcc7;
  border-radius: 4px;
  border: 2px solid #151d34;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
`

export const StyledScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 15px 15px;
  min-height: 0;
  border-left: 2px solid #596f07;
  border-right: 2px solid #596f07;
  border-bottom: 2px solid #596f07;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`

export const StyledMetadataTitle = styled.p`
  font-family: Open Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 28px;
  color: ${black};
`

export const StyledMetadataSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const StyledMetadataItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledStandardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledMetadataLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & > div {
    margin-bottom: 0;
    line-height: 0;
    display: flex;
    align-items: center;
  }

  svg {
    display: block;
  }
`
export const StyledMetadataLabel = styled.p`
  margin: 0;
  font-family: Open Sans;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #262626;
`
export const StyledStandardIdentifier = styled.p`
  font-family: Open Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #151d34;
`
export const StyledStandardDescription = styled.p`
  font-family: Open Sans;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #555555;
`

export const StyledStandardLowConfidenceWarning = styled.p`
  color: #7e5d00;
  font-family: 'Open Sans';
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 18px;
`
export const StyledDivider = styled.div`
  width: 100%;
  height: 0px;
  background-color: #d9d9d9;
  border: 0.5px solid #d9d9d9;
`
export const StyledSelect = styled(Select)`
  & > .ant-select-selection {
    width: 120px;
    background: transparent !important;
    border: none !important;
    &:focus {
      outline: none;
      box-shadow: none !important;
    }
    &:hover {
      border: none !important;
      box-shadow: none !important;
    }
    & > .ant-select-selection__rendered {
      margin-left: 0px !important;
    }
  }
`
export const StyledStandardIdentifierContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`
export const StyledStandardEditContainer = styled.div`
  cursor: pointer;
`
export const StyledStandardTooltipWrapper = styled.div`
  cursor: pointer;
`
export const StyledMoreStandards = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  color: #20845e;
  font-family: 'Open Sans';
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;

  &:hover {
    color: #144b36;
  }

  &:hover svg {
    fill: #144b36;
  }
`

export const StyledAdditionalStandardsModal = styled(Modal)`
  .ant-modal-header {
    padding: 16px 24px;
    border-bottom: 1px solid #e8e8e8;
  }

  .ant-modal-title {
    color: #151d34;
    font-family: 'Open Sans';
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
  }

  .ant-modal-body {
    padding: 20px 24px;
    max-height: 55vh;
    overflow-y: auto;
  }

  .ant-modal-close-x {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    font-size: 18px;
    color: #151d34;
  }
`

export const StyledStandardsAddedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const StyledStandardsAddedRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const StyledSuggestionsList = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledSuggestionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 0;
  border-bottom: 1px solid #e8e8e8;

  &:first-child {
    padding-top: 0;
  }
`

export const StyledSuggestionRowHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`

export const StyledSuggestionStatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  flex-shrink: 0;
`

export const StyledCurrentlyUsedLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #20845e;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  white-space: nowrap;

  svg {
    flex-shrink: 0;
  }
`

export const StyledRemoveAction = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #cc4100;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`

export const StyledUseSuggestionButton = styled(EduButton)`
  &&& {
    height: 32px;
    min-width: unset;
    margin: 0;
    padding: 0 14px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }
`

export const StyledBrowseFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-top: 16px;
`

export const StyledBrowseFooterText = styled.p`
  margin: 0;
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: #151d34;
`

export const StyledBrowseStandardsLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #20845e;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;

  &:hover {
    color: #144b36;
  }
`

export const StyledNoStandardsSelected = styled.p`
  margin: 0;
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #555555;
`

export const StyledApplyButton = styled.div`
  margin-top: 20px;
  width: 100%;

  button {
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
  }
`
export const StyledShowSuggestionsButton = styled.div`
  width: 100%;

  button {
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
  }
`

export const StyledLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 0;
  gap: 16px;
  width: 100%;
`

export const StyledSpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40px;

  .ant-spin {
    margin: 0;
  }
`

export const StyledGradientLoader = styled.div`
  width: 36px;
  height: 36px;
  position: relative;
  border-radius: 50%;
  animation: loaderRotate 1.2s linear infinite;
  background: conic-gradient(
    from 135deg,
    #e8efed 0deg,
    #d0dfdb 45deg,
    #a8ccc3 90deg,
    #7ab5a8 135deg,
    #5a9e8c 180deg,
    #438576 225deg,
    #3a7d6e 315deg
  );
  mask: radial-gradient(
      farthest-side,
      transparent calc(100% - 7px),
      #000 calc(100% - 7px)
    ),
    conic-gradient(
      from 135deg,
      transparent 0deg,
      #000 0deg,
      #000 270deg,
      transparent 270deg
    );
  mask-composite: intersect;
  -webkit-mask: radial-gradient(
      farthest-side,
      transparent calc(100% - 5px),
      #000 calc(100% - 7px)
    ),
    conic-gradient(
      from 135deg,
      transparent 0deg,
      #000 0deg,
      #000 270deg,
      transparent 315deg
    );
  -webkit-mask-composite: source-in;

  @keyframes loaderRotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

export const StyledErrorText = styled(Text)`
  display: block;
  padding: 16px;
  background-color: #fff1f0;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  color: ${dangerColor};
  font-size: 12px;
  line-height: 18px;
`

export const StyledEmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
export const StyledEmptyStateText = styled.p`
  font-family: Open Sans;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 14px;
  line-height: 22px;
  color: ${({ color }) => color || '#555555'};
  margin-top: ${({ marginTop }) => marginTop || '20px'};
`
export const StyledThinkingText = styled.div`
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 500;
  color: ${greyThemeDark1};
  text-align: center;
`

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 30px;

  @media (max-width: ${smallDesktopWidth}) {
    order: -1;
    width: 100%;
    margin-top: 0;
    padding: 0 22px 0px 36px;
  }
`

export const StyledRecommendationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const StyledRecommendationItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const StyledRecommendationLabel = styled.p`
  font-family: Open Sans;
  font-weight: 900;
  font-size: 12px;
  line-height: 18px;
  color: #555555;
`

export const StyledRecommendationText = styled.p`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #555555;
`

export const StyledRecommendationList = styled.ul`
  margin: 0;
  padding-left: 16px;
  list-style-type: disc;
`

export const StyledRecommendationListItem = styled.li`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #555555;
`

export const StyledStandardTooltipContainer = styled.div`
  text-align: left;
  font-size: 12px;
`

export const StyledStandardTooltipRow = styled.div`
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const StyledStandardTooltipLabel = styled.span`
  font-weight: 600;
`

export const StyledStandardSetInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StyledStandardSetLabel = styled.p`
  margin: 0 0 8px 0;
  font-family: Open Sans;
  font-weight: 700;
  font-style: Bold;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 20px;
  vertical-align: middle;
  color: #262626;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StyledStandardSetDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`

export const StyledStandardSetTooltipContent = styled.p`
  margin: 0;
  font-family: Open Sans;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #474747;
  white-space: normal;
`

const StandardSetTooltip = ({ className, children, ...props }) => (
  <Tooltip {...props} overlayClassName={className}>
    {children}
  </Tooltip>
)

export const StyledStandardSetTooltip = styled(StandardSetTooltip)`
  max-width: 276px;

  .ant-tooltip-content {
    .ant-tooltip-arrow {
      display: none;
    }

    .ant-tooltip-inner {
      background-color: #ffffff;
      border: 1px solid #d8d8d8;
      border-radius: 4px;
      box-shadow: 0 4px 6px 2px rgba(0, 0, 0, 0.08);
      padding: 12px 16px;
    }
  }
`

export const StyledStandardSetSelect = styled(Select)`
  width: 100%;

  & > .ant-select-selection {
    background: ${white} !important;
    border: 1px solid ${PEAR_ASSIST_STANDARD_SET_SELECT_COLOR} !important;
    border-radius: 4px;
    box-shadow: none !important;
    height: 40px !important;

    &:focus,
    &:hover {
      border-color: ${PEAR_ASSIST_STANDARD_SET_SELECT_COLOR} !important;
      box-shadow: none !important;
    }

    & > .ant-select-selection__rendered {
      margin-left: 12px !important;
      margin-right: 36px !important;
      line-height: 38px !important;
      font-family: Open Sans;
      font-size: 14px;
      font-weight: 400;
      color: ${PEAR_ASSIST_STANDARD_SET_SELECT_COLOR};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ant-select-selection-selected-value {
      color: ${PEAR_ASSIST_STANDARD_SET_SELECT_COLOR} !important;
    }

    .ant-select-selection__placeholder {
      color: ${PEAR_ASSIST_STANDARD_SET_SELECT_COLOR};
      opacity: 0.55;
    }
  }

  &.ant-select-focused > .ant-select-selection,
  &.ant-select-open > .ant-select-selection {
    border-color: ${PEAR_ASSIST_STANDARD_SET_SELECT_COLOR} !important;
    box-shadow: none !important;
  }

  .ant-select-arrow {
    color: ${PEAR_ASSIST_STANDARD_SET_SELECT_COLOR};
    right: 12px;
    margin-top: -6px;
  }

  .ant-select-arrow .anticon {
    color: ${PEAR_ASSIST_STANDARD_SET_SELECT_COLOR};
  }

  .ant-select-arrow svg,
  .ant-select-arrow svg path {
    fill: ${PEAR_ASSIST_STANDARD_SET_SELECT_COLOR};
  }
`

export const StyledAIContentFeedbackWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`

export const StyledAIContentFeedbackLabel = styled.span`
  font-family: Open Sans;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 20px;
  color: #262626;
`

export const StyledAIContentFeedbackButton = styled.button`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${({ $active, $activeColor }) =>
    $active ? $activeColor || '#1AB394' : 'transparent'};
  border: 1px solid
    ${({ $active, $activeColor }) =>
      $active ? $activeColor || '#1AB394' : '#151D34'};
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`
export const StyledAIContentFeedbackButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`
export const StyledAIContentFeedbackContainer = styled.div`
  margin-top: 17px;
  padding-right: 10px;
`

export const StyledDisclaimerText = styled.p`
  color: #555;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin-top: 10px;
`

export const StyledDisclaimerLink = styled.a`
  color: #555;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`
